export default __webpack_public_path__ + "static/media/history.479d52ba.svg";